import React, {useEffect, useState} from 'react'
import {useParams, Link} from 'react-router-dom'
import {getBlogDetail} from './_requests'
import {PostModel} from './BlogModels'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Helmet} from 'react-helmet-async'

const BlogDetail: React.FC = () => {
  const {slug} = useParams<{slug: string}>()
  const [post, setPost] = useState<PostModel | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchPost = async () => {
      try {
        setLoading(true)
        const response = await getBlogDetail(slug!)
        setPost(response.data)
      } catch (e) {
        setError('خطا در بارگذاری مقاله')
      } finally {
        setLoading(false)
      }
    }
    fetchPost()
  }, [slug])

  if (loading) return <div>در حال بارگذاری...</div>
  if (error) return <div className='alert alert-danger'>{error}</div>
  if (!post) return <div>مقاله پیدا نشد.</div>

  return (
    <>
      <Helmet>
        <title>{post?.title}</title>
        <meta name='description' content={post?.description} />
        <meta property='og:title' content={post?.title} />
        <meta property='og:description' content={post?.description} />
      </Helmet>
      <div className='card'>
        <div className='card-body'>
          <h1>{post.title}</h1>
          <div className='mb-3 d-flex align-items-center' style={{fontSize: '0.95rem'}}>
            {post.category && (
              <Link
                to={`/blog/category/${post.category.slug}`}
                className='badge bg-light-primary text-primary fw-bold ms-2 d-flex align-items-center'
                style={{textDecoration: 'none'}}
              >
                <KTIcon iconName='tag' className='fs-5 ms-1' />
                {post.category.name}
              </Link>
            )}
            <span className='text-muted d-flex align-items-center'>
              <KTIcon iconName='calendar' className='fs-5 ms-1' />
              {new Date(post.created_at).toLocaleDateString('fa-IR')}
            </span>
          </div>
          <div className='mb-5'>
            <img src={toAbsoluteUrl(post.image)} alt={post.title} style={{maxWidth: '100%'}} />
          </div>
          <div dangerouslySetInnerHTML={{__html: post.content}} />
        </div>
      </div>
    </>
  )
}

export {BlogDetail}
